<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-8 left-container">
    <h3 class="mt-3 text-center welcome-title">{{ "Welcome to Up Career" | translate }}</h3>


    <div class="social-row mt-4" *ngIf="activeTab === 'user'">
      <button class="linkedin-btn" (click)="registerWithLinkedIn()" type="button">
        <img src="../../../../assets/img/linkedIn-auth.svg" alt="LinkedIn" />
        {{ "Signup with LinkedIn" | translate }}
      </button>
      <button class="google-btn border-0" (click)="registerWithGoogle()" type="button">
        <img src="../../../../assets/img/google.svg" alt="Google" />
        {{ "Signup with Google" | translate }}
      </button>
    </div>

    <div class="or-divider mt-3" *ngIf="activeTab === 'user'">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>

    <form *ngIf="activeTab === 'user'" [formGroup]="userForm" (ngSubmit)="signUp()">
      <h3 class="mt-3 text-center">{{ "Create an Account" | translate }}</h3>

      <div class="row mt-2">
        <div class="col-12 col-sm-6">
          <label>{{ "Full Name" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-person fs-3 left-icon"></i>
            <input type="text" placeholder="{{ 'Enter your name' | translate }}"
              formControlName="name"
              [class.error]="hasError('name')"
              [class.success]="isValid('name')" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('name')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('name')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('name')">{{ getErrorMessage('name') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Phone Number" | translate }}</label>
          <div class="input-container mt-1 phone-input-wrapper">
            <div class="phone-flag-prefix" (click)="toggleCountryDropdown()" #countryTrigger>
              <img [src]="selectedCountry.flag" [alt]="selectedCountry.code" class="flag-img" />
              <span class="country-code">{{ selectedCountry.dial }}</span>
              <i class="bi bi-chevron-down chevron-icon" [class.rotated]="showCountryDropdown"></i>
            </div>
            <div class="country-dropdown" *ngIf="showCountryDropdown">
              <div class="country-search-wrapper">
                <i class="bi bi-search country-search-icon"></i>
                <input type="text" class="country-search-input" placeholder="Search country..."
                  [(ngModel)]="countrySearch" [ngModelOptions]="{ standalone: true }"
                  (click)="$event.stopPropagation()" />
              </div>
              <ul class="country-list">
                <li *ngFor="let country of filteredCountries" (click)="selectCountry(country)"
                  [class.active]="selectedCountry.code === country.code">
                  <img [src]="country.flag" [alt]="country.code" class="flag-img" />
                  <span class="country-name">{{ country.name }}</span>
                  <span class="country-dial">{{ country.dial }}</span>
                </li>
              </ul>
            </div>
            <input type="tel" placeholder="{{ 'Enter your phone number' | translate }}"
              formControlName="phoneNumber"
              [class.error]="hasError('phoneNumber')"
              [class.success]="isValid('phoneNumber')"
              class="phone-input" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('phoneNumber')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('phoneNumber')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('phoneNumber')">{{ getErrorMessage('phoneNumber') }}</div>
        </div>
      </div>

      <div class="mt-3">
        <label>{{ "Email" | translate }} <span class="required-asterisk">*</span></label>
        <div class="input-container mt-1">
          <i class="bi bi-envelope left-icon"></i>
          <input type="email" placeholder="{{ 'Enter your email' | translate }}"
            formControlName="email"
            [class.error]="hasError('email')"
            [class.success]="isValid('email')"
            autocomplete="email" />
          <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('email')"></i>
          <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('email')"></i>
        </div>
        <div class="error-message" *ngIf="hasError('email')">{{ getErrorMessage('email') }}</div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-sm-6">
          <label>{{ "Password" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-lock left-icon"></i>
            <input [type]="showPassword ? 'text' : 'password'"
              placeholder="{{ 'Enter your password' | translate }}"
              formControlName="password"
              [class.error]="hasError('password')"
              [class.success]="isValid('password')"
              autocomplete="new-password" />
            <i class="eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye' }}" (click)="toggleShowPassword()"></i>
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('password')" style="right: 50px !important;"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('password')" style="right: 50px !important;"></i>
          </div>
          <div class="error-message" *ngIf="hasError('password')">{{ getErrorMessage('password') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Confirm password" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-lock left-icon"></i>
            <input [type]="showConfirmPassword ? 'text' : 'password'"
              placeholder="{{ 'Renter your password' | translate }}"
              formControlName="confirmPassword"
              [class.error]="hasError('confirmPassword')"
              [class.success]="isValid('confirmPassword')"
              autocomplete="new-password" />
            <i class="eye-icon {{ showConfirmPassword ? 'bi-eye-slash' : 'bi bi-eye' }}" (click)="toggleConfirmShowPassword()"></i>
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('confirmPassword')" style="right: 50px !important;"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('confirmPassword')" style="right: 50px !important;"></i>
          </div>
          <div class="error-message" *ngIf="hasError('confirmPassword')">{{ getErrorMessage('confirmPassword') }}</div>
        </div>
      </div>

      <button type="submit" class="w-100 gradient-button mt-3" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ "Register" | translate }}</span>
        <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
          <i class="bi bi-arrow-clockwise spin me-2"></i>{{ "Processing..." | translate }}
        </span>
      </button>
    </form>

    <form *ngIf="activeTab === 'company'" [formGroup]="companyForm" (ngSubmit)="signUp()">
      <h3 class="mt-3 text-center">{{ "Create a Company Account" | translate }}</h3>

      <div class="row mt-2">
        <div class="col-12 col-sm-6">
          <label>{{ "Company Name" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-building left-icon"></i>
            <input type="text" placeholder="{{ 'Enter company name' | translate }}"
              formControlName="name"
              [class.error]="hasError('name')"
              [class.success]="isValid('name')" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('name')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('name')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('name')">{{ getErrorMessage('name') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Email" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-envelope left-icon"></i>
            <input type="email" placeholder="{{ 'Enter company email' | translate }}"
              formControlName="email"
              [class.error]="hasError('email')"
              [class.success]="isValid('email')"
              autocomplete="email" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('email')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('email')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('email')">{{ getErrorMessage('email') }}</div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-sm-6">
          <label>{{ "Owner Name" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-person left-icon"></i>
            <input type="text" placeholder="{{ 'Enter owner name' | translate }}"
              formControlName="ownerName"
              [class.error]="hasError('ownerName')"
              [class.success]="isValid('ownerName')" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('ownerName')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('ownerName')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('ownerName')">{{ getErrorMessage('ownerName') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Phone Number" | translate }}</label>
          <div class="input-container mt-1 phone-input-wrapper">
            <div class="phone-flag-prefix" (click)="toggleCountryDropdown()" #countryTrigger>
              <img [src]="selectedCountry.flag" [alt]="selectedCountry.code" class="flag-img" />
              <span class="country-code">{{ selectedCountry.dial }}</span>
              <i class="bi bi-chevron-down chevron-icon" [class.rotated]="showCountryDropdown"></i>
            </div>
            <div class="country-dropdown" *ngIf="showCountryDropdown">
              <div class="country-search-wrapper">
                <i class="bi bi-search country-search-icon"></i>
                <input type="text" class="country-search-input" placeholder="Search country..."
                  [(ngModel)]="countrySearch" [ngModelOptions]="{ standalone: true }"
                  (click)="$event.stopPropagation()" />
              </div>
              <ul class="country-list">
                <li *ngFor="let country of filteredCountries" (click)="selectCountry(country)"
                  [class.active]="selectedCountry.code === country.code">
                  <img [src]="country.flag" [alt]="country.code" class="flag-img" />
                  <span class="country-name">{{ country.name }}</span>
                  <span class="country-dial">{{ country.dial }}</span>
                </li>
              </ul>
            </div>
            <input type="tel" placeholder="{{ 'Enter phone number' | translate }}"
              formControlName="phoneNumber"
              [class.error]="hasError('phoneNumber')"
              [class.success]="isValid('phoneNumber')"
              class="phone-input" />
          </div>
          <div class="error-message" *ngIf="hasError('phoneNumber')">{{ getErrorMessage('phoneNumber') }}</div>
        </div>
      </div>

      <div class="mt-3">
        <label>{{ "Responsible Persons" | translate }}</label>
        <div class="input-container mt-1">
          <i class="bi bi-people left-icon"></i>
          <input type="text" placeholder="{{ 'e.g. John Doe, Jane Smith' | translate }}"
            formControlName="responsiblePersons" />
        </div>
        <small class="text-muted ps-2">{{ "Separate names with commas" | translate }}</small>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-sm-6">
          <label>{{ "Company Size From" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-diagram-3 left-icon"></i>
            <input type="number" placeholder="10"
              formControlName="companySizeFrom"
              [class.error]="hasError('companySizeFrom')"
              [class.success]="isValid('companySizeFrom')" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('companySizeFrom')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('companySizeFrom')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('companySizeFrom')">{{ getErrorMessage('companySizeFrom') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Company Size To" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-diagram-3 left-icon"></i>
            <input type="number" placeholder="50"
              formControlName="companySizeTo"
              [class.error]="hasError('companySizeTo')"
              [class.success]="isValid('companySizeTo')" />
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('companySizeTo')"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('companySizeTo')"></i>
          </div>
          <div class="error-message" *ngIf="hasError('companySizeTo')">{{ getErrorMessage('companySizeTo') }}</div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-sm-6">
          <label>{{ "Password" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-lock left-icon"></i>
            <input [type]="showPassword ? 'text' : 'password'"
              placeholder="{{ 'Enter your password' | translate }}"
              formControlName="password"
              [class.error]="hasError('password')"
              [class.success]="isValid('password')"
              autocomplete="new-password" />
            <i class="eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye' }}" (click)="toggleShowPassword()"></i>
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('password')" style="right: 50px !important;"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('password')" style="right: 50px !important;"></i>
          </div>
          <div class="error-message" *ngIf="hasError('password')">{{ getErrorMessage('password') }}</div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Confirm password" | translate }} <span class="required-asterisk">*</span></label>
          <div class="input-container mt-1">
            <i class="bi bi-lock left-icon"></i>
            <input [type]="showConfirmPassword ? 'text' : 'password'"
              placeholder="{{ 'Renter your password' | translate }}"
              formControlName="confirmPassword"
              [class.error]="hasError('confirmPassword')"
              [class.success]="isValid('confirmPassword')"
              autocomplete="new-password" />
            <i class="eye-icon {{ showConfirmPassword ? 'bi-eye-slash' : 'bi bi-eye' }}" (click)="toggleConfirmShowPassword()"></i>
            <i class="validation-icon success bi bi-check-circle" *ngIf="isValid('confirmPassword')" style="right: 50px !important;"></i>
            <i class="validation-icon error bi bi-exclamation-circle" *ngIf="hasError('confirmPassword')" style="right: 50px !important;"></i>
          </div>
          <div class="error-message" *ngIf="hasError('confirmPassword')">{{ getErrorMessage('confirmPassword') }}</div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-sm-6">
          <label>{{ "Tax Registration" | translate }}</label>
          <div class="file-upload-wrapper mt-1">
            <label class="file-upload-label">
              <i class="bi bi-file-earmark-arrow-up"></i>
              <span>{{ taxRegistrationFile ? taxRegistrationFile.name : ('Upload file' | translate) }}</span>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onTaxRegistrationChange($event)" hidden />
            </label>
          </div>
        </div>

        <div class="col-12 col-sm-6 mt-3 mt-sm-0">
          <label>{{ "Commercial Registration" | translate }}</label>
          <div class="file-upload-wrapper mt-1">
            <label class="file-upload-label">
              <i class="bi bi-file-earmark-arrow-up"></i>
              <span>{{ commercialRegistrationFile ? commercialRegistrationFile.name : ('Upload file' | translate) }}</span>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onCommercialRegistrationChange($event)" hidden />
            </label>
          </div>
        </div>
      </div>

      <button type="submit" class="w-100 gradient-button mt-3" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ "Register" | translate }}</span>
        <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
          <i class="bi bi-arrow-clockwise spin me-2"></i>{{ "Processing..." | translate }}
        </span>
      </button>
    </form>

    <div class="text-center mt-4">
      {{ "Already have an account?" | translate }}
      <span class="bold-text" routerLink="/login">{{ "Login" | translate }}</span>
    </div>
  </div>

  <div class="d-none d-md-flex col-md-4 col-lg-4 right-container">
    <img class="logo-img" src="../../../../assets/img/logo.png" alt="Logo" />
    <img class="auth-group-img mt-3" src="../../../../assets/img/authGroup.svg" alt="Auth Group" />
  </div>
</div>